import {
    MapPin,
    Plane,
    Train,
    Briefcase,
    Heart,
    Users,
    Bus,
    Calendar,
    Car,
} from "lucide-react";

export const SERVICES = [
    {
        slug: "local-taxi",
        title: "Local Taxi",
        desc: "Local car hire with driver: 120 KM / 12 hours plus fuel. Compare vehicle rates and extra-hour charges before booking.",
        href: "/fleet",
        action: "View local hire rates",
        icon: Car,
    },
    {
        slug: "outstation-taxi",
        title: "Outstation Taxi",
        desc: "Plan an outstation trip with driver. Per-KM rates include fuel, with minimum billing of 300 KM per day; other trip charges are extra.",
        href: "/outstation",
        action: "Plan an outstation trip",
        icon: MapPin,
    },
    {
        slug: "airport-taxi",
        title: "Airport Pickup & Drop",
        desc: "Request an airport pickup or drop. Share the airport, flight details, pickup address, passengers and luggage to confirm the transfer plan.",
        href: "/airport-transfer",
        action: "View airport transfers",
        icon: Plane,
    },
    {
        slug: "railway-pickup",
        title: "Railway Pickup & Drop",
        desc: "Arrange station pickup or drop with your train details and exact station name. Confirm the meeting point, timing and fare in advance.",
        href: "/railway-transfer",
        action: "View railway transfers",
        icon: Train,
    },
    {
        slug: "corporate-cab",
        title: "Corporate Cab Services",
        desc: "Request cars or group vehicles for business trips and office visits. Share reporting times, routes and invoicing requirements for a tailored quote.",
        href: "/contact?service=corporate-cab#contact",
        action: "Request a corporate quote",
        icon: Briefcase,
    },
    {
        slug: "wedding-car-rental",
        title: "Wedding Car Rental",
        desc: "Arrange cars and Tempo Travellers for wedding travel and guest transfers. Confirm venues, timings, decoration and multiple-vehicle requirements.",
        href: "/contact?service=wedding-car-rental#contact",
        action: "Plan wedding transport",
        icon: Heart,
    },
    {
        slug: "employee-transportation",
        title: "Employee Transportation",
        desc: "Plan staff pickup and drop with shift timings, passenger numbers and pickup stops. Vehicle, driver duty and contract terms are confirmed separately.",
        href: "/contact?service=employee-transportation#contact",
        action: "Enquire about staff transport",
        icon: Users,
    },
    {
        slug: "tempo-traveller",
        title: "Tempo Traveller Rental",
        desc: "13, 17, 20, 21 and 26-seater Tempo Travellers with AC, music and pushback seats. All seat totals include the driver.",
        href: "/tempo-traveller-rental",
        action: "Compare Tempo Travellers",
        icon: Bus,
    },
    {
        slug: "monthly-cab",
        title: "Monthly Cab Services",
        desc: "Request monthly vehicle hire with your working days, duty hours, expected kilometres and pickup locations. Confirm fuel and payment terms in the quote.",
        href: "/contact?service=monthly-cab#contact",
        action: "Request a monthly quote",
        icon: Calendar,
    },
];
